






import { Editor as TipTapEditor, EditorContent } from '@tiptap/vue-2';
import Text from '@tiptap/extension-text';
import type { Field, MergeValues, TextContentDoc } from '@getaccept/editor-lib';
import { EnterBreakNode, InputDocNode, MergeValueNode, ParagraphNode } from '@getaccept/editor-lib';
import type { PropType, Ref } from '@vue/composition-api';
import {
  ref,
  onBeforeUnmount,
  onMounted,
  watch,
  computed,
  defineComponent,
} from '@vue/composition-api';
import { updateMergeValues, setContent } from './helpers/prosemirror-viewer.helper';

export default defineComponent({
  name: 'ProsemirrorViewerFormOption',
  components: {
    EditorContent,
  },
  props: {
    content: {
      type: [Object, String] as PropType<TextContentDoc | string>,
      default: '',
    },
    isUpdating: { type: Boolean },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
  },
  setup(props) {
    const viewer: Ref<TipTapEditor | null> = ref(null);

    const contentPayload = computed(() => {
      return {
        viewer: viewer.value,
        content: props.content,
        fields: props.fields,
        mergeValues: props.mergeValues,
      };
    });

    const inputViewer = computed(() => {
      return {
        content: props.content,
        editable: false,
        enableInputRules: false,
        enablePasteRules: false,
        extensions: [InputDocNode, ParagraphNode, Text, MergeValueNode, EnterBreakNode],
      };
    });

    onMounted(() => {
      viewer.value = new TipTapEditor(inputViewer.value);
      updateMergeValues(contentPayload.value);
    });

    onBeforeUnmount(() => {
      viewer.value.destroy();
    });

    watch(
      () => [props.fields, props.mergeValues],
      () => {
        updateMergeValues(contentPayload.value);
      }
    );

    watch(
      () => props.content,
      () => {
        setContent(contentPayload.value);
      }
    );

    return {
      viewer,
    };
  },
});
